module.exports = __webpack_public_path__ + "static/img/5.05878e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/5.png
// module id = PgLh
// module chunks = 0